import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import link from "../assets/link.svg";
import Nav from "../components/Nav";
import InputField from "../components/InputField";
import { usePoints } from "../providers/PointsContext";
import { useCurrentPage } from "../providers/CurrentPageContext";
import { useModal } from "./../providers/ModalContext";

function Register({ alias, gameId }) {
  const [points, setPoints] = usePoints();
  const [ageChecked, setAgeChecked] = useState(false);
  const [gdprChecked, setGdprChecked] = useState(false);
  const [validated, setValidated] = useState(false);
  const [currentPage, setCurrentPage] = useCurrentPage();
  const { openModal } = useModal();

  const initialFormData = {
    nickname: alias,
    email: "",
    phone: "",
    sessionId: gameId,
    score: points,
  };
  const fulaOrd = ["snopp", "snippa", "skit", "röv", "bajs", "knull", "fittan", "knulla", "kuk", "fitta", "hora", "horunge", "aina", "dildo", "neger", "granat", "bomb", "pistol", "kpist", "kulspruta", "mord", "anal", "fittor", "smäll på käften", "fitt", "hasch", "lsd", "kokain", "heroin", "boffa", "marijuana", "nigger", "hamas", "halshugg", "jihad", "nazi", "runka", "ftp", "Knark", "Droger", "Röv ", "vagina", "Snopp ", "Snippa", "balle", "fjong", "Stånd", "sperma", "Sex", "Buttplug", "Syfilis", "Klamydia", "HIV", "AIDS", "herpes", "Gonorré", "Kondylom", "cannabis", "amfetamin", "Metamfetamin ", "Fenmetralin", "Khat", "Betelnöt", "Ritalina", "MDPV ", "3-MCC", "freebase", "Rökheroin", "Opium", "Jude", "Islam", "tjack", "Mdma", "gevär", "Automatkarbin", "Pansarskott", "Vapen", "torped", "sprängning", "Nazist", "Hitler", "Stalin", "Pinochet", "Putin", "Zedong", "Mussolini", "Il-sung", "Hussein", "Fascism", "örfil", "pungspark", "mobbing", "fylla", "sjukdom", "covid", "nigger", "fista", "fisting", "Snorre", "Gloryhole", "Pedofil", "Peddo", "Turk", "Piss", "Bög", "runka", "onanera ", "onani", "svartskalle", "rödskinn", "zigenare", "semit", "tattare"];
  const [formData, setFormData] = useState(initialFormData);

  const handleInputChange = (event) => {
    const { id, value } = event.target;
    if (id === 'phone') {
      // Remove non-digit characters from the input
      const sanitizedValue = value.replace(/\D/g, '');
      setFormData({
        ...formData,
        [id]: sanitizedValue,
      });
      return;
    }
    if (id === "nickname") {
      // Split the input value into words
      let words = value.split(/\s+/);

      // Filter out the banned words
      words = words.filter(word => !fulaOrd.includes(word.toLowerCase()));

      // Join the words back into a string
      const sanitizedValue = words.join(" ");

      // Update the formData for nickname with the sanitized value
      // Assuming you have a way to update your formData here
      setFormData({ ...formData, nickname: sanitizedValue });
      return;
    }
    setFormData({
      ...formData,
      [event.target.id]: event.target.value,
    });
  };

  useEffect(() => {
    if (
      !ageChecked ||
      !gdprChecked ||
      formData.nickname === "" ||
      formData.nickname.length < 3 ||
      formData.email === "" ||
      formData.phone === ""
    ) {
      setValidated(false);
    } else {
      setValidated(true);
    }
  }, [ageChecked, gdprChecked, formData.name, formData.email, formData.phone]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData(initialFormData);
    const addUser = await fetch(`${process.env.REACT_APP_API_URL}/adduser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    setCurrentPage(6);
  };

  const inputFields = [
    {
      id: "nickname",
      placeholder: "Namn",
      value: formData.nickname,
      type: "text",
      pattern: "*",
      onChange: handleInputChange,
    },
    {
      id: "email",
      placeholder: "E-post",
      value: formData.email,
      type: "email",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$",
      onChange: handleInputChange,
    },
    {
      id: "phone",
      placeholder: "Mobilnummer",
      value: formData.phone,
      type: "text",
      pattern: "^[0-9]{1,10}$",
      maxLength: 10,
      onChange: handleInputChange,
      isRef: true,
    },
  ];

  return (
    <section className="bg-syren-500">
      <Nav />
      <div className="container">
        <h1 className="mb-12">Inskick</h1>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col justify-center items-center"
        >
          <div className="flex flex-col gap-[30px]">
            {inputFields.map((field) => (
              <InputField

                key={field.id}
                id={field.id}
                placeholder={field.placeholder}
                value={field.value}
                onChange={field.onChange}
                type={field.type}
                maxLength={field?.maxLength || 55}
                pattern={field.pattern || ""}
              />
            ))}
          </div>

          <div className="mt-20 flex flex-col gap-6 mb-11">
            {/** <Link
              to="/villkor"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Tävlingsvillkor
              <img src={link} alt="link" className="ml-2" />
            </Link> <Link
              to="/tävlingsregler"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Tävlingsregler <img src={link} alt="link" className="ml-2" />
            </Link>
            <Link
              to="/gdpr"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              GDPR <img src={link} alt="link" className="ml-2" />
            </Link>*/}
            <a className="underline cursor-pointer" onClick={() => openModal('Conditions')}>
              Tävlingsvillkor
              <img src={link} alt="link" className="ml-2" />
            </a>
            <a className="underline cursor-pointer" onClick={() => openModal('Rules')}>
              Tävlingsregler
              <img src={link} alt="link" className="ml-2" />
            </a>
            <a className="underline cursor-pointer" onClick={() => openModal('Gdpr')}>
              GDPR
              <img src={link} alt="link" className="ml-2" />
            </a>
            
          </div>
          <div>
            <div className="flex items-start mb-4">
              <input
                type="checkbox"
                id="age"
                required
                onChange={() => setAgeChecked((checked) => !checked)}
                className="mt-1 mr-2"
              />
              <p className="text-sm max-w-sm">
                <label htmlFor="age">Jag är över 16 år.</label></p>
            </div>
            <div className="flex items-start">
              <input
                type="checkbox"
                id="gdpr"
                required
                onChange={() => setGdprChecked((checked) => !checked)}
                className="mt-1 mr-2"
              />
              <p className="text-sm max-w-sm">
                <label htmlFor="gdpr" className="text-sm">
                  Jag har läst reglerna, godkänner villkoren samt godkänner att
                  mitt namn används på topplistan och i Frölunda Torgs kanaler.
                </label>
              </p>
            </div>
          </div>
          <button
            type="submit"
            disabled={!validated}
            className="mt-5 next disabled:opacity-50"
          >
            Skicka in
          </button>
        </form>
      </div>
    </section>
  );
}

export default Register;
